<div 
    class="container-order-card"
    [class.active]="active()"
    [class.mouse-outside]="!isMouseInsideContainer()">

    <div class="container-header">
        <div class="container-titles">
            <p class="ra-label-s bold">{{ order()?.client?.name || ('order.common.clientNotFound' | translate) }}</p>
            <p class="ra-label-xs content-secondary">{{ order()?.description || ('order.common.noDescription' | translate) }}</p>
        </div>

        <!-- Código da ordem de serviço: identificação curta que o cliente usa
             para se referir à OS (e pela qual a busca também casa). -->
        @if (order()?.code) {
            <ra-badge
                [label]="'order.common.codeLabel' | translate: { code: order()?.code }"
                [variant]="'primary'"
                [tooltip]="'order.common.codeTooltip' | translate"
                [tooltipPosition]="'left'"
            />
        }
    </div>
</div>
